import { gql, useMutation, useQuery } from "@apollo/client";
import { useAuth } from "@src/auth";
import { markAllNotificationsAsReadForUser } from "@src/graphql/mutations";
import { getNotificationsByUserId } from "@src/graphql/queries";
import { getNotificationsForUser } from "queries";
import { useState } from "react";
import sortBy from "lodash.sortby";
import reverse from "lodash.reverse";
import NotificationsDropdown from "./NotificationsDropdown";
import NotificationMenuIcon from "@components/NotificationIcon";
import styles from "./style.module.css";

export default function NotificationsMenu({
  userType,
  icon,
  expanded,
  setExpanded,
}) {
  const userId = useAuth()?.user?.username;

  const { data, loading, refetch } = useQuery(gql(getNotificationsByUserId), {
    variables: { userId, last: 10 },
    pollInterval: 5000,
  });

  const [
    markNotificationsAsRead,
    { data: updateData, loading: mutationLoading, error, reset },
  ] = useMutation(gql(markAllNotificationsAsReadForUser), {
    variables: {
      userId,
    },
    refetchQueries: [getNotificationsForUser],
  });

  const edges = data?.getNotificationsByUserId?.edges ?? [];

  const result = edges.map((edge) => edge.node);
  let notifications = result ?? [];

  let unread = false;

  if (notifications?.length) {
    notifications.forEach((item) => {
      if (item?.read === false) {
        unread = true;
      }
    });
  }

  notifications = reverse(
    sortBy(notifications, (item) => item.dateCreated)
  ).slice(0, 3);

  function expand() {
    setTimeout(() => {
      setExpanded(true);
    }, 200);
  }

  function close() {
    markNotificationsAsRead();
    refetch();
    setTimeout(() => {
      setExpanded(false);
    }, 200);
  }

  return (
    <div className="dropdown">
      <div
        tabIndex={0}
        onFocus={expand}
        onBlur={close}
        className={styles.center}
      >
        {icon}
        {unread && <div className={styles.unreadDotNavbar}></div>}
        {expanded ? (
          <NotificationsDropdown
            userType={userType}
            notifications={notifications}
          />
        ) : null}
      </div>
    </div>
  );
}
